import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import AuthenticatorHeader from "../components/AuthenticatorHeader"
import { isProd } from "../config"

const components = {
  Header: AuthenticatorHeader,
}

export default function Login() {
  console.log("> Login")
  const { route } = useAuthenticator((context) => [context.route])
  // console.log("Login: Auth.route =", route)
  const location = useLocation()
  const navigate = useNavigate()
  let prevUrl = location.state?.from?.pathname
  if (!prevUrl || prevUrl.startsWith("/login")) {
    prevUrl = "/"
  }
  // console.log("Login: prevUrl =", prevUrl)
  useEffect(() => {
    !isProd && console.log("Login.useEffect: Auth.route =", route)
    if (route === "authenticated") {
      !isProd && console.log("Login.useEffect: navigating to", prevUrl)
      /** @todo Should this trigger un-cached user data reload? */
      navigate(prevUrl, {
        state: { from: location },
        replace: true,
      })
    }
  }, [location, navigate, prevUrl, route])
  return <Authenticator components={components} />
}

export const Component = Login
